export const INPUT_WIDTH = 288;
